// CSP: Set a special variable to add `nonce` attributes to all styles/script tags

const elWithNonce = document.querySelector('[nonce]');

/* global __webpack_nonce__ */
__webpack_nonce__ = elWithNonce ? elWithNonce.getAttribute('nonce') : null;
